module.exports = __webpack_public_path__ + "static/media/3_1.43a7edf3.jpg";